export const StatusCode = Object.freeze({
    "UNAUTHORIZED": 401,
    "NOT_FOUND" : 404
})